import { Component } from "react";

import TranslationMapper from "i18n/mapper";
import LanguageProvider from "providers/languageProvider";

import IconImageNotFoundActive from "../../assets/img/image-not-found-active.svg";
import IconImageNotFoundInactive from "../../assets/img/image-not-found-inactive.svg";

import IActivityItemProps from "./interfaces/IActivityItemProps";

export default class ActivityItem extends Component<IActivityItemProps> {
  public constructor(props: IActivityItemProps) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.imageSrc = this.imageSrc.bind(this);
  }

  public imageSrc(): string {
    if (this.props.active) {
      return this.props.activity.activeImageExists ? this.props.imageUri : IconImageNotFoundActive;
    }
    return this.props.activity.inactiveImageExists ? this.props.imageUri : IconImageNotFoundInactive;
  }

  public render(): JSX.Element {
    const name = this.props.name !== "" ? this.props.name : LanguageProvider.t(TranslationMapper.images.namenotfound);
    return (
      <button
        onClick={this.onClick}
        type="button"
        title={name}
        className={`btn btn--image-label mb-3 ${this.props.active ? "active" : "inactive"}`}
      >
        <img src={this.imageSrc()} alt="" />
        <div>{name}</div>
      </button>
    );
  }

  private onClick(): void {
    if (this.props.selectingDisabled) {
      return;
    }

    this.props.onItemClick(this.props.activity);
  }
}
